<p>group-social works!</p>
<div *ngIf="band.spotifyURL">this is spotify url only if there is one: {{band.spotifyURL}}</div>